import LiquidText from '../components/LiquidText';
import { OrcamentoIcon } from '../components/OrcamentoUI';
import { useLiquidFeedback, LiquidDialog } from '../components/LiquidUI';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import WorkItemsManager from '../components/WorkItemsManager';
import './Obras.css';

const Obras = () => {
    const liquidFeedback = useLiquidFeedback();
    const [obras, setObras] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('ativas');
    const [showWorkItemsManager, setShowWorkItemsManager] = useState(false);
    const [viewMode, setViewMode] = useState(() => {
        const saved = localStorage.getItem('obrasViewMode');
        return saved || 'grid';
    });
    const [importResult, setImportResult] = useState(null);
    const fileInputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchObras();
    }, []);

    // ... (keep existing fetchObras)

    const fetchObras = async () => {
        try {
            const response = await api.get('/obras');
            console.log('Obras response:', response.data);
            setObras(response.data.obras || []);
        } catch (error) {
            console.error('Error fetching obras:', error);
            setObras([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('pt-PT');
    };

    const getStatusBadge = (status) => {
        const statusMap = {
            'planeada': { label: 'Planeada', class: 'status-planned' },
            'em_curso': { label: 'Em Curso', class: 'status-active' },
            'concluida': { label: 'Concluída', class: 'status-completed' },
            'suspensa': { label: 'Suspensa', class: 'status-suspended' }
        };
        const normalizedStatus = status ? status.toLowerCase() : '';
        const s = statusMap[normalizedStatus] || { label: status, class: '' };
        return <span className={`status-badge ${s.class}`}><LiquidText>{s.label}</LiquidText></span>;
    };

    const filteredObras = obras
        .filter(obra => {
            const matchesSearch = obra.posicao?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                obra.cliente?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                obra.descricao?.toLowerCase().includes(searchTerm.toLowerCase());

            const matchesStatus = filterStatus === 'todos' ? true :
                filterStatus === 'ativas' ? (obra.status === 'em_curso' || obra.status === 'planeada') :
                    filterStatus === 'em_curso' ? obra.status === 'em_curso' :
                        filterStatus === 'planeadas' ? obra.status === 'planeada' :
                            filterStatus === 'concluidas' ? (obra.status === 'concluida' || obra.status === 'recebida') : true;

            return matchesSearch && matchesStatus;
        })
        .sort((a, b) => {
            const dateA = a.data_inicio ? new Date(a.data_inicio) : new Date('9999-12-31');
            const dateB = b.data_inicio ? new Date(b.data_inicio) : new Date('9999-12-31');
            return dateA - dateB; // Earliest first
        });

    const handleDownloadTemplate = async () => {
        try {
            const response = await api.get('/obras/template/download', {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template_obras.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading template:', error);
            liquidFeedback.notify('Erro ao descarregar template');
        }
    };

    const handleFileSelect = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await api.post('/obras/import/excel', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setImportResult(response.data);
            fetchObras(); // Refresh list

            // Reset file input
            event.target.value = '';
        } catch (error) {
            console.error('Error importing file:', error);
            liquidFeedback.notify('Erro ao importar ficheiro: ' + (error.response?.data?.message || error.message));
        }
    };

    return (
        <div className="obras-page">
            {/* Top Bar Uniforme */}
            <div className="top-bar">
                <div className="top-bar-left">
                    <div className="top-bar-title">
                        <h1><OrcamentoIcon name="building" fallback="🏗️" /> Gestão de Obras</h1>
                        <p>Gerir obras e gerar documentação</p>
                    </div>
                </div>
                <div className="top-bar-actions">
                    <button
                        className="btn-secondary"
                        onClick={() => setShowWorkItemsManager(true)}
                    >
                        <OrcamentoIcon name="settings" fallback="⚙️" /> Gerir Trabalhos
                    </button>
                    <button
                        className="btn-secondary"
                        onClick={handleDownloadTemplate}
                    >
                        <OrcamentoIcon name="download" fallback="📥" /> Template Excel
                    </button>
                    <button
                        className="btn-secondary"
                        onClick={() => fileInputRef.current?.click()}
                    >
                        <OrcamentoIcon name="upload" fallback="📤" /> Importar Excel
                    </button>
                    <button className="btn-primary" onClick={() => navigate('/obras/nova')}>
                        + Nova Obra
                    </button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                    />
                </div>
            </div>

            {showWorkItemsManager && (
                <WorkItemsManager
                    onClose={() => setShowWorkItemsManager(false)}
                />
            )}

            {/* Conteúdo da Página */}
            <div className="page-content">
                <div className="shared-search">
                    <input
                        type="text"
                        placeholder="Pesquisar obras por cliente ou local..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* Filtros + Toggle na mesma linha */}
                <div className="liquid-list-toolbar" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className="shared-subnav">
                        <button className={`shared-subnav-btn ${filterStatus === 'ativas' ? 'active' : ''}`} onClick={() => setFilterStatus('ativas')}>Ativas</button>
                        <button className={`shared-subnav-btn ${filterStatus === 'planeadas' ? 'active' : ''}`} onClick={() => setFilterStatus('planeadas')}>Planeadas</button>
                        <button className={`shared-subnav-btn ${filterStatus === 'em_curso' ? 'active' : ''}`} onClick={() => setFilterStatus('em_curso')}>Em Curso</button>
                        <button className={`shared-subnav-btn ${filterStatus === 'concluidas' ? 'active' : ''}`} onClick={() => setFilterStatus('concluidas')}>Concluídas</button>
                        <button className={`shared-subnav-btn ${filterStatus === 'todos' ? 'active' : ''}`} onClick={() => setFilterStatus('todos')}>Todas</button>
                    </div>
                    <div className="liquid-view-toggle" role="group" aria-label="Modo de visualização" data-liquid-surface="true" style={{ display: 'flex', background: '#f8fafc', padding: '4px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <button
                            aria-pressed={viewMode === 'grid'}
                            onClick={() => { setViewMode('grid'); localStorage.setItem('obrasViewMode', 'grid'); }}
                            style={{ padding: '6px 12px', border: 'none', borderRadius: '6px', background: viewMode === 'grid' ? 'white' : 'transparent', cursor: 'pointer', boxShadow: viewMode === 'grid' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', display: 'flex', alignItems: 'center', gap: '6px' }}
                        ><OrcamentoIcon name="dashboard" fallback="🏗️" /> Grelha</button>
                        <button
                            aria-pressed={viewMode === 'list'}
                            onClick={() => { setViewMode('list'); localStorage.setItem('obrasViewMode', 'list'); }}
                            style={{ padding: '6px 12px', border: 'none', borderRadius: '6px', background: viewMode === 'list' ? 'white' : 'transparent', cursor: 'pointer', boxShadow: viewMode === 'list' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none', display: 'flex', alignItems: 'center', gap: '6px' }}
                        ><OrcamentoIcon name="list" fallback="📋" /> Lista</button>
                    </div>
                </div>

                {loading ? (
                <div className="loading-state">Carregando obras...</div>
            ) : filteredObras.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon"><OrcamentoIcon name="building" fallback="🏗️" /></span>
                    <h3>Nenhuma obra encontrada</h3>
                    <p>Comece por criar uma nova obra</p>
                    <button className="btn-primary" onClick={() => navigate('/obras/nova')}>
                        + Nova Obra
                    </button>
                </div>
            ) : (
                <>
                    {viewMode === 'grid' ? (
                        <div className="obras-grid">
                            {filteredObras.map((obra) => (
                                <div key={obra.id} className="obra-card" onClick={() => navigate(`/obras/${obra.id}`)}>
                                    <div className="card-header">
                                        <span className="posicao">{obra.posicao}</span>
                                        {getStatusBadge(obra.status)}
                                    </div>
                                    <div className="card-body">
                                        <h4>{obra.cliente}</h4>
                                        <p>{obra.descricao}</p>
                                    </div>
                                    <div className="obra-footer">
                                        <div className="obra-actions">
                                            <button className="action-btn" onClick={(e) => { e.stopPropagation(); navigate(`/obras/${obra.id}`); }} title="Ver Obra"><OrcamentoIcon name="eye" fallback="👁️" /></button>
                                            <button className="action-btn" onClick={(e) => { e.stopPropagation(); navigate(`/obras/${obra.id}/editar`); }} title="Editar"><OrcamentoIcon name="edit" fallback="✏️" /></button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div data-liquid-surface="true" className="table-responsive" style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                            <table className="standard-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                    <tr>
                                        <th style={{ padding: '12px 15px', textAlign: 'left', color: '#4a5568', fontWeight: '600' }}>Posição</th>
                                        <th style={{ padding: '12px 15px', textAlign: 'left', color: '#4a5568', fontWeight: '600' }}>Cliente</th>
                                        <th style={{ padding: '12px 15px', textAlign: 'left', color: '#4a5568', fontWeight: '600' }}>Descrição</th>
                                        <th style={{ padding: '12px 15px', textAlign: 'center', color: '#4a5568', fontWeight: '600' }}>Estado</th>
                                        <th style={{ padding: '12px 15px', textAlign: 'center', color: '#4a5568', fontWeight: '600' }}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredObras.map((obra) => (
                                        <tr
                                            key={obra.id}
                                            onClick={() => navigate(`/obras/${obra.id}`)}
                                            style={{ borderBottom: '1px solid #edf2f7', cursor: 'pointer', transition: 'background 0.2s' }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f7fafc'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <td style={{ padding: '12px 15px', fontWeight: 'bold', color: '#2d3748' }}>{obra.posicao}</td>
                                            <td style={{ padding: '12px 15px', color: '#4a5568' }}>{obra.cliente}</td>
                                            <td style={{ padding: '12px 15px', color: '#718096', maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{obra.descricao}</td>
                                            <td style={{ padding: '12px 15px', textAlign: 'center' }}>{getStatusBadge(obra.status)}</td>
                                            <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                                                <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); navigate(`/obras/${obra.id}`); }}
                                                        title="Ver Obra" className="obra-list-action"
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}
                                                    >
                                                        <OrcamentoIcon name="eye" fallback="👁️" />
                                                    </button>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); navigate(`/obras/${obra.id}/editar`); }}
                                                        title="Editar" className="obra-list-action"
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' }}
                                                    >
                                                        <OrcamentoIcon name="edit" fallback="✏️" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
            </div>

            {/* Import Result Modal */}
            {importResult && (
                <LiquidDialog onClose={() => setImportResult(null)} className="modal-overlay" onClick={() => setImportResult(null)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px' }}>
                        <div className="modal-header">
                            <h2><OrcamentoIcon name="chart" fallback="📊" /> Resultado da Importação</h2>
                            <button className="close-btn" onClick={() => setImportResult(null)}>×</button>
                        </div>
                        <div style={{ padding: '24px' }}>
                            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                                <div style={{ flex: 1, background: '#d4edda', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '2rem', marginBottom: '5px' }}><OrcamentoIcon name="check" fallback="✅" /></div>
                                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#155724' }}>{importResult.imported}</div>
                                    <div style={{ fontSize: '0.9rem', color: '#155724' }}>Obras criadas</div>
                                </div>
                                {importResult.failed > 0 && (
                                    <div data-liquid-surface="true" style={{ flex: 1, background: '#f8d7da', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ fontSize: '2rem', marginBottom: '5px' }}><OrcamentoIcon name="close" fallback="❌" /></div>
                                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#721c24' }}>{importResult.failed}</div>
                                        <div style={{ fontSize: '0.9rem', color: '#721c24' }}>Erros</div>
                                    </div>
                                )}
                            </div>

                            {importResult.details?.errors?.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <h4 style={{ marginBottom: '10px', color: '#721c24' }}>Erros encontrados:</h4>
                                    <div data-liquid-surface="true" style={{ maxHeight: '200px', overflowY: 'auto', background: '#f8f9fa', padding: '10px', borderRadius: '6px' }}>
                                        {importResult.details.errors.map((err, idx) => (
                                            <div key={idx} style={{ padding: '8px', borderBottom: '1px solid #dee2e6', fontSize: '0.9rem' }}>
                                                <strong>Linha {err.row}:</strong> {err.message}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                                <button className="btn-primary" onClick={() => setImportResult(null)}>
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </LiquidDialog>
            )
            }
        </div >
    );
};

export default Obras;
